import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
    FaStore, FaUsers, FaSignOutAlt, FaCar, FaChartBar, 
    FaUserFriends, FaHome, FaBell, FaCog, FaChartLine,
    FaTimes, FaBars, FaArrowRight
} from 'react-icons/fa';

export default function AdminDashboard({ logout }) {
    const navigate = useNavigate();
    const [data, setData] = useState({ sucursales: [], total_garantia: 0 });
    const [alertas, setAlertas] = useState([]);
    const [activeBottomTab, setActiveBottomTab] = useState('home');
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());

    const fetchData = async () => {
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/dashboard');
            setData(res.data);
        } catch (error) { 
            console.error("Error cargando datos financieros:", error); 
        }
    };

    const fetchAlertas = async () => {
    try {
        const res = await axios.get('https://api.alquilacarbolivia.com/api/inventario/alertas-criticas');
        // Si la respuesta es un array, lo guardamos
        if (Array.isArray(res.data)) {
            setAlertas(res.data);
        }
    } catch (error) { 
        console.error("Error al conectar con el servicio de alertas:", error.message);
        setAlertas([]); // Limpiar alertas si falla
    }
};

    useEffect(() => {
        fetchData();
        fetchAlertas();
        const timer = setInterval(() => setCurrentTime(new Date()), 60000);
        return () => clearInterval(timer);
    }, []);

    const sucursalesMenu = [
        { 
            id: 1, 
            nombre: 'COMO EN CASA', 
            nombreCorto: 'Como en Casa',
            gradient: 'linear-gradient(135deg, #D31027 0%, #EA384D 100%)',
            color: '#D31027',
            onColor: '#ffffff',
            icon: <FaStore />,
        },
        { 
            id: 2, 
            nombre: 'YUM YUM SUC. 1',
            nombreCorto: 'Yum Yum 1', 
            gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            color: '#11998e',
            onColor: '#ffffff',
            icon: <FaStore />,
        },
        { 
            id: 3, 
            nombre: 'YUM YUM SUC. 2',
            nombreCorto: 'Yum Yum 2', 
            gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
            color: '#f7971e',
            onColor: '#3b2a00',
            icon: <FaStore />,
        },
        { 
            id: 4, 
            nombre: 'ALQUILACAR',
            nombreCorto: 'Alquilacar', 
            gradient: 'linear-gradient(135deg, #f12711 0%, #f5af19 100%)',
            color: '#f12711',
            onColor: '#ffffff',
            icon: <FaCar />,
        }
    ];

    const totalIngresos = data.sucursales.reduce((sum, s) => sum + parseFloat(s.total_vendido || 0), 0);

    const irASucursal = (suc) => suc.id === 4 ? navigate('/alquilacar') : navigate(`/sucursal/${suc.id}`);

    // Bottom Navigation Items
    const bottomNavItems = [
        { id: 'home', icon: <FaHome />, label: 'Inicio' },
        { id: 'stats', icon: <FaChartLine />, label: 'Estadísticas' },
        { id: 'alerts', icon: <FaBell />, label: 'Alertas', badge: alertas.length },
        { id: 'more', icon: <FaCog />, label: 'Más' }
    ];

    return (
        <div style={{ 
            minHeight: '100vh',
            background: '#f8fafc',
            paddingBottom: '80px', // Espacio para bottom nav
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            
            {/* ==================== MOBILE HEADER ==================== */}
            <div className="d-lg-none" style={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                boxShadow: '0 2px 12px rgba(0,0,0,0.1)'
            }}>
                <div className="d-flex align-items-center justify-content-between p-3">
                    <div className="d-flex align-items-center">
                        <div style={{
                            width: '40px',
                            height: '40px',
                            background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            color: 'white',
                            marginRight: '12px'
                        }}>
                            CR
                        </div>
                        <div>
                            <div className="text-white fw-bold" style={{ fontSize: '1.1rem' }}>
                                Control-Rest
                            </div>
                            <small className="text-white-50" style={{ fontSize: '0.7rem' }}>
                                {currentTime.toLocaleDateString('es-BO', { day: 'numeric', month: 'short' })}
                            </small>
                        </div>
                    </div>
                    
                    <button 
                        className="btn btn-link text-white p-2"
                        onClick={() => setShowMobileMenu(!showMobileMenu)}
                        style={{ fontSize: '1.5rem' }}
                    >
                        {showMobileMenu ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* Mobile Menu Dropdown */}
                {showMobileMenu && (
                    <div style={{
                        background: '#1e293b',
                        borderTop: '1px solid rgba(255,255,255,0.1)',
                        padding: '1rem'
                    }}>
                        <button 
                            className="btn btn-outline-light btn-sm w-100 mb-2 text-start"
                            onClick={() => { navigate('/admin/reportes'); setShowMobileMenu(false); }}
                        >
                            <FaChartBar className="me-2"/> Reportes
                        </button>
                        <button 
                            className="btn btn-outline-light btn-sm w-100 mb-2 text-start"
                            onClick={() => { navigate('/admin/usuarios'); setShowMobileMenu(false); }}
                        >
                            <FaUsers className="me-2"/> Usuarios
                        </button>
                        <button 
                            className="btn btn-outline-light btn-sm w-100 mb-2 text-start"
                            onClick={() => { navigate('/admin/clientes'); setShowMobileMenu(false); }}
                        >
                            <FaUserFriends className="me-2"/> Clientes
                        </button>
                        <button 
                            className="btn btn-danger btn-sm w-100 text-start"
                            onClick={logout}
                        >
                            <FaSignOutAlt className="me-2"/> Cerrar Sesión
                        </button>
                    </div>
                )}
            </div>

            {/* ==================== DESKTOP NAVBAR ==================== */}
            <nav className="navbar navbar-expand-lg navbar-dark shadow-lg d-none d-lg-flex" style={{ 
                background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                borderBottom: '3px solid #f59e0b'
            }}>
                <div className="container-fluid px-4">
                    <div className="d-flex align-items-center">
                        <div className="me-3" style={{
                            width: '45px',
                            height: '45px',
                            background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            color: 'white',
                            boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)'
                        }}>
                            CR
                        </div>
                        <div>
                            <div className="navbar-brand fw-bold mb-0" style={{ fontSize: '1.3rem' }}>
                                CONTROL-REST
                            </div>
                            <small className="text-white-50 d-block" style={{ marginTop: '-5px', fontSize: '0.7rem' }}>
                                Panel de Administración
                            </small>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <div className="text-white-50 me-3" style={{ fontSize: '0.85rem' }}>
                            {currentTime.toLocaleDateString('es-BO', { weekday: 'short', day: 'numeric', month: 'short' })}
                        </div>

                        {alertas.length > 0 && (
                            <div className="position-relative me-2">
                                <FaBell className="text-warning" style={{ fontSize: '1.3rem' }}/>
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.6rem' }}>
                                    {alertas.length}
                                </span>
                            </div>
                        )}

                        <button className="btn btn-outline-light btn-sm rounded-pill px-3" onClick={() => navigate('/admin/reportes')}>
                            <FaChartBar className="me-2"/> Reportes
                        </button>
                        <button className="btn btn-outline-light btn-sm rounded-pill px-3" onClick={() => navigate('/admin/usuarios')}>
                            <FaUsers className="me-2"/> Usuarios
                        </button>
                        <button className="btn btn-outline-light btn-sm rounded-pill px-3" onClick={() => navigate('/admin/clientes')}>
                            <FaUserFriends className="me-2"/> Clientes
                        </button>
                        <button className="btn btn-danger btn-sm rounded-pill px-3" onClick={logout}>
                            <FaSignOutAlt className="me-1"/> Salir
                        </button>
                    </div>
                </div>
            </nav>

            {/* ==================== MAIN CONTENT ==================== */}
            <div className="container-fluid px-3 px-lg-4 py-3 py-lg-4">
                
                {/* TOTAL DEL DÍA: número grande + barra que reparte el total entre negocios */}
                <div className="mb-4 px-1">
                    <div className="text-muted" style={{ fontSize: '0.85rem' }}>Ingresos de hoy</div>
                    <div className="fw-bold" style={{
                        fontSize: 'clamp(2rem, 6vw, 3rem)',
                        color: '#0f172a',
                        letterSpacing: '-0.02em',
                        lineHeight: 1.1
                    }}>
                        Bs {totalIngresos.toFixed(2)}
                    </div>
                    <div className="d-flex mt-3" style={{ height: '8px', borderRadius: '99px', overflow: 'hidden', background: '#e2e8f0', gap: '2px' }}>
                        {totalIngresos > 0 && sucursalesMenu.map(suc => {
                            const d = data.sucursales.find(s => s.nombre === suc.nombre);
                            const m = d ? parseFloat(d.total_vendido || 0) : 0;
                            if (m <= 0) return null;
                            return (
                                <div
                                    key={`bar-${suc.id}`}
                                    title={`${suc.nombreCorto}: Bs ${m.toFixed(2)}`}
                                    style={{ width: `${(m / totalIngresos) * 100}%`, background: suc.gradient }}
                                />
                            );
                        })}
                    </div>
                </div>

                {/* TARJETAS DE SUCURSAL: acceso + ganancia en una sola tarjeta */}
                <div className="row g-3 g-lg-4">
                    {sucursalesMenu.map(suc => {
                        const montoData = data.sucursales.find(s => s.nombre === suc.nombre);
                        const monto = montoData ? parseFloat(montoData.total_vendido || 0) : 0;
                        const porcentaje = totalIngresos > 0 ? ((monto / totalIngresos) * 100).toFixed(1) : '0.0';

                        return (
                            <div key={suc.id} className="col-12 col-sm-6 col-lg-3">
                                <div
                                    className="suc-card"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => irASucursal(suc)}
                                    onKeyDown={e => { if (e.key === 'Enter') irASucursal(suc); }}
                                >
                                    <div className="suc-hero" style={{ background: suc.gradient, color: suc.onColor }}>
                                        <div className="suc-watermark">{suc.icon}</div>
                                        <div className="suc-icon" style={{ background: 'rgba(255,255,255,0.28)' }}>
                                            {suc.icon}
                                        </div>
                                        <span className="suc-pill" style={{ background: 'rgba(255,255,255,0.28)' }}>Hoy</span>
                                    </div>

                                    <div className="suc-body">
                                        <div className="fw-bold" style={{ fontSize: '1.15rem', color: '#0f172a' }}>
                                            {suc.nombreCorto}
                                        </div>
                                        <div className="text-muted" style={{ fontSize: '0.75rem', marginBottom: '0.5rem' }}>
                                            Ganancia del día
                                        </div>
                                        <div className="fw-bold" style={{ color: suc.color, fontSize: 'clamp(1.6rem, 4vw, 2rem)', letterSpacing: '-0.01em' }}>
                                            Bs {monto.toFixed(2)}
                                        </div>
                                    </div>

                                    <div className="suc-footer" style={{ background: suc.gradient, color: suc.onColor }}>
                                        <div className="suc-cell">
                                            <div className="fw-bold" style={{ fontSize: '1.05rem' }}>{porcentaje}%</div>
                                            <div style={{ fontSize: '0.7rem', opacity: 0.85 }}>del total</div>
                                        </div>
                                        <div className="suc-cell suc-cell-action">
                                            <div className="fw-bold" style={{ fontSize: '0.95rem' }}>
                                                Administrar <FaArrowRight style={{ fontSize: '0.75rem', marginLeft: '4px' }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* ==================== BOTTOM NAVIGATION (Mobile Only) ==================== */}
            <div 
                className="d-lg-none"
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'white',
                    borderTop: '1px solid #e5e7eb',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
                    zIndex: 1000,
                    paddingBottom: 'env(safe-area-inset-bottom)' // Para iPhones con notch
                }}
            >
                <div className="d-flex justify-content-around align-items-center" style={{ height: '65px' }}>
                    {bottomNavItems.map(item => (
                        <button
                            key={item.id}
                            className="btn border-0 position-relative d-flex flex-column align-items-center justify-content-center"
                            style={{
                                flex: 1,
                                height: '100%',
                                color: activeBottomTab === item.id ? '#3b82f6' : '#94a3b8',
                                background: 'transparent',
                                transition: 'all 0.2s'
                            }}
                            onClick={() => setActiveBottomTab(item.id)}
                        >
                            <div style={{ fontSize: '1.4rem', marginBottom: '2px' }}>
                                {item.icon}
                            </div>
                            <div style={{ fontSize: '0.65rem', fontWeight: '500' }}>
                                {item.label}
                            </div>
                            {item.badge > 0 && (
                                <span 
                                    className="position-absolute badge rounded-pill bg-danger"
                                    style={{ 
                                        top: '8px',
                                        right: '50%',
                                        transform: 'translateX(15px)',
                                        fontSize: '0.6rem',
                                        padding: '2px 5px'
                                    }}
                                >
                                    {item.badge}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* ESTILOS GLOBALES */}
            <style>{`
                /* Smooth scroll */
                html {
                    scroll-behavior: smooth;
                }

                /* Touch optimization */
                * {
                    -webkit-tap-highlight-color: transparent;
                }

                .suc-card {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    background: #fff;
                    border-radius: 22px;
                    overflow: hidden;
                    cursor: pointer;
                    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.10);
                    transition: transform 0.25s ease, box-shadow 0.25s ease;
                }
                .suc-card:focus-visible { outline: 3px solid #3b82f6; outline-offset: 2px; }
                .suc-card:active { transform: scale(0.98); }
                @media (min-width: 992px) {
                    .suc-card:hover {
                        transform: translateY(-6px);
                        box-shadow: 0 18px 36px rgba(15, 23, 42, 0.18);
                    }
                }
                .suc-hero { position: relative; height: 130px; padding: 16px; overflow: hidden; }
                @media (min-width: 992px) { .suc-hero { height: 170px; } }
                .suc-watermark {
                    position: absolute; right: -14px; bottom: -22px;
                    font-size: 9rem; opacity: 0.18; line-height: 1;
                }
                .suc-icon {
                    width: 52px; height: 52px; border-radius: 16px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 1.5rem; backdrop-filter: blur(4px);
                }
                .suc-pill {
                    position: absolute; top: 16px; right: 16px;
                    padding: 4px 12px; border-radius: 99px;
                    font-size: 0.75rem; font-weight: 600;
                }
                .suc-body { flex: 1; padding: 18px 20px 20px; }
                .suc-footer { display: flex; }
                .suc-cell {
                    flex: 1; padding: 12px 16px;
                    display: flex; flex-direction: column;
                    justify-content: center; align-items: center; text-align: center;
                }
                .suc-cell + .suc-cell { border-left: 1px solid rgba(255,255,255,0.35); }
                .suc-cell-action { flex: 1.4; }
                @media (prefers-reduced-motion: reduce) { .suc-card { transition: none; } }

                /* Prevent scroll when mobile menu is open */
                body.menu-open {
                    overflow: hidden;
                }

                /* Safe area for iPhone notch */
                @supports (padding: max(0px)) {
                    .container-fluid {
                        padding-left: max(12px, env(safe-area-inset-left));
                        padding-right: max(12px, env(safe-area-inset-right));
                    }
                }

                /* Responsive text */
                @media (max-width: 576px) {
                    h1 { font-size: 1.5rem !important; }
                    h2 { font-size: 1.3rem !important; }
                    h3 { font-size: 1.1rem !important; }
                }
            `}</style>
        </div>
    );
}
